module.exports = __webpack_public_path__ + "img/u2466.8f518f80.png";